import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { classnames, fDate } from '@aibees/shared/utils';
import { useTeamMemberFilter } from '@aibees/shared/views/user-management-view/context/team-member-filter-context';
import { TeamMemberTable } from '@aibees/shared/views/user-management-view/features/team-member-table';
import { Box, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { CreditTeamMemberProps as Props } from './types';

export const CreditTeamMember = memo(({ className }: Props) => {
  const { data } = useCurrentSubscriptionApi();
  const { startDate, endDate } = useTeamMemberFilter();

  const currentPlan = data?.current;

  return (
    <Styled.Wrapper
      className={classnames('CreditTeamMember', className)}
      variant="outlined"
    >
      <Stack
        sx={SX.header}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Stack direction="row" alignItems="center" gap={0.5}>
          <Typography variant="body3" fontWeight={700} color="grey.700">
            Credit Usage by Team Members
          </Typography>
        </Stack>
        <Typography variant="body4" fontWeight={400}>
          {fDate(startDate ?? currentPlan?.currentPeriodStart)} -{' '}
          {fDate(endDate ?? currentPlan?.currentPeriodEnd)}
        </Typography>
      </Stack>
      <Box sx={SX.tableWrapper}>
        <TeamMemberTable inCurrentPlan />
      </Box>
    </Styled.Wrapper>
  );
});

CreditTeamMember.displayName = 'CreditTeamMember';
